import { Component, input, model, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'app-dialog-selection-bar',
	templateUrl: './dialog-selection-bar.component.html',
	styleUrls: ['./dialog-selection-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogSelectionBarComponent<T> {
	selection = model.required<T>();

	selections = input<T[]>([]);
}
